mutation ReplySupportRequest($id: ID!, $input: ReplySupportRequestInput!) {
  replySupportRequest(id: $id, input: $input) {
    id
    status
    lastMessageAt
    waitingSince
    closedAt
    assignee {
      id
      displayName
      email
    }
  }
}
